<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.625" y="2.625" width="14.75" height="10.7529" stroke="currentColor" stroke-width="1.25"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 8.55963V10.5596H8.5V8.55963H10.5V7.55963L8.5 7.55963V5.55963H7.5V7.55963L5.5 7.55963V8.55963H7.5Z" fill="currentColor"/>
</svg>
